export default __webpack_public_path__ + "static/media/other-icon.b278ee83.svg";